import { useQuery } from "@tanstack/react-query";
import { restApiRequest, EMPLOYEE_MANAGEMENT_SERVICE } from "src/utils/Api";
import { mockData } from "src/utils/Company";
import sortByField from "src/utils/jsHelpers/sortByField";

const useCompanyRentableGroupsOptions = (companyId: string, enabled: boolean) =>
  useQuery({
    enabled,
    queryKey: [
      "employee-management-rentable-groups",
      { companyId, itemsPerPage: 10000 },
    ],
    queryFn: () =>
      restApiRequest(
        EMPLOYEE_MANAGEMENT_SERVICE,
        `/rentable-groups?itemsPerPage=10000&companyId=${companyId}`,
        "GET",
        {},
        mockData
      ),
    initialData: [],
    select: (
      data: {
        id: string;
        frontendName: string;
      }[]
    ) =>
      sortByField(
        data?.map(({ frontendName, id }) => ({
          value: id,
          label: frontendName,
        })) || [],
        "label"
      ),
  });

export default useCompanyRentableGroupsOptions;
